/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 3:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   serializeForm: () => (/* binding */ serializeForm)
/* harmony export */ });
var serializeForm = function serializeForm(form) {
  var arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
    if (field.type === 'select-multiple') {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push("".concat(encodeURIComponent(field.name), "=").concat(encodeURIComponent(option.value)));
      });
      return;
    }
    if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
    arr.push("".concat(encodeURIComponent(field.name), "=").concat(encodeURIComponent(field.value)));
  });
  return arr.join('&');
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _api_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

if (!window.customElements.get('variant-tabs')) {
  var VariantTabs = /*#__PURE__*/function (_HTMLElement) {
    function VariantTabs() {
      var _this;
      _classCallCheck(this, VariantTabs);
      _this = _callSuper(this, VariantTabs);
      _this.toggle = _this.getElementsByClassName('swatch-toggle')[0];
      _this.currentVariant = _this.getElementsByClassName('swatch-title')[0];
      _this.tabWrapper = _this.getElementsByClassName('var-tabs')[0];
      _this.tabs = Array.from(_this.getElementsByClassName('var-tab'));
      _this.tabButtons = Array.from(_this.getElementsByClassName('swatch-item')).filter(function (tab) {
        return !tab.classList.contains('swatch-toggle');
      });
      return _this;
    }
    _inherits(VariantTabs, _HTMLElement);
    return _createClass(VariantTabs, [{
      key: "toggleTab",
      value: function toggleTab(variantId) {
        for (var i = 0; i < this.tabs.length; i += 1) {
          var currTab = this.tabs[i];
          if (currTab.dataset.variantId === variantId) {
            currTab.classList.add('is-active');
          } else {
            currTab.classList.remove('is-active');
          }
        }
      }
    }, {
      key: "toggleDropdown",
      value: function toggleDropdown() {
        if (this.classList.contains('is-open')) this.classList.remove('is-open');else this.classList.add('is-open');
      }
    }, {
      key: "setCurrentVariant",
      value: function setCurrentVariant(btn) {
        this.currentVariant.textContent = btn.querySelector('.swatch-title').textContent;
        this.toggle.style.cssText = btn.style.cssText;
      }
    }, {
      key: "handleBtn",
      value: function handleBtn(btn) {
        if (!btn) return;
        this.toggleDropdown();
        if (btn.classList.contains('swatch-toggle')) return;
        this.setCurrentVariant(btn);
        this.toggleTab(btn.value);
      }
    }, {
      key: "addEvents",
      value: function addEvents() {
        var _this2 = this;
        this.addEventListener('click', function (e) {
          _this2.handleBtn(e.target.closest('.swatch-item'));
        });
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.addEvents();
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define('variant-tabs', VariantTabs);
}
if (!window.customElements.get('tab-info')) {
  var TabInfo = /*#__PURE__*/function (_HTMLElement2) {
    function TabInfo() {
      var _this3;
      _classCallCheck(this, TabInfo);
      _this3 = _callSuper(this, TabInfo);
      _this3.tabWrapper = _this3.getElementsByClassName('tabs')[0];
      _this3.tabs = Array.from(_this3.getElementsByClassName('tab'));
      _this3.tabButtons = Array.from(_this3.getElementsByClassName('tab-title'));
      return _this3;
    }
    _inherits(TabInfo, _HTMLElement2);
    return _createClass(TabInfo, [{
      key: "toggleTab",
      value: function toggleTab() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1';
        // const zeroIndex = parseInt(index) - 1;
        for (var i = 0; i < this.tabs.length; i += 1) {
          var currTab = this.tabs[i];
          var currBtn = this.tabButtons[i];
          if (currTab.dataset.index === index) {
            currTab.classList.add('is-active');
            currBtn.classList.add('is-active');
          } else {
            currTab.classList.remove('is-active');
            currBtn.classList.remove('is-active');
          }
        }
      }
    }, {
      key: "addEvents",
      value: function addEvents() {
        var _this4 = this;
        this.addEventListener('click', function (e) {
          var btn = e.target.closest('.tab-title');
          if (!btn) return;
          _this4.toggleTab(btn.dataset.index);
        });
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.addEvents();
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define('tab-info', TabInfo);
}
if (!window.customElements.get('product-gallery')) {
  var ProductGallery = /*#__PURE__*/function (_HTMLElement3) {
    function ProductGallery() {
      var _this5;
      _classCallCheck(this, ProductGallery);
      _this5 = _callSuper(this, ProductGallery);
      _defineProperty(_this5, "observerCallback", function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            _this5.moveSlide(entry.target);
          }
        });
      });
      _this5.slider = _this5.getElementsByClassName('gallery-images')[0];
      _this5.slides = Array.from(_this5.getElementsByClassName('gallery-image'));
      _this5.thumbs = Array.from(_this5.getElementsByClassName('thumb-button'));
      _this5.activeThumb = _this5.thumbs[0];
      _this5.index = 0;
      _this5.observe = true;
      return _this5;
    }
    _inherits(ProductGallery, _HTMLElement3);
    return _createClass(ProductGallery, [{
      key: "updateMedia",
      value: function updateMedia(_ref) {
        var media = _ref.media;
        console.log('update media', media);
      }

      /* 
        when a slide leaves frame,
        stick the next one on the other end: */
    }, {
      key: "scrollTo",
      value: function scrollTo(slide) {
        this.slider.scrollTo(slide.offsetLeft, 0);
      }
    }, {
      key: "scrollToStart",
      value: function scrollToStart() {
        this.thumbIndex = 0;
        this.scrollTo(this.slides[1]);
      }
    }, {
      key: "scrollToEnd",
      value: function scrollToEnd() {
        this.thumbIndex = this.thumbs.length - 1;
        /* move the previous slide or the last one: */
        this.scrollTo(this.slides[this.slides.length - 2]);
      }
    }, {
      key: "setActiveThumb",
      value: function setActiveThumb() {
        this.activeThumb.classList.remove('is-active');
        this.activeThumb = this.thumbs[this.thumbIndex];
        this.activeThumb.classList.add('is-active');
      }
    }, {
      key: "moveSlide",
      value: function moveSlide(el) {
        var _this6 = this;
        var scrollToSlide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var index = parseInt(el.dataset.index);
        if (typeof index === 'undefined' || this.index === index || !this.observe) return;
        this.prevIndex = this.index;
        this.index = index;
        this.thumbIndex = index;
        if (index < 0) this.scrollToEnd();else if (index >= this.slides.length - 2) this.scrollToStart();
        if (scrollToSlide) {
          this.slider.classList.add('is-hidden');
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(function () {
            _this6.scrollTo(_this6.slides[_this6.thumbIndex + 1]);
            _this6.slider.classList.remove('is-hidden');
          }, 300);
        }
        this.setActiveThumb();
      }
    }, {
      key: "addEvents",
      value: function addEvents() {
        var _this7 = this;
        this.addEventListener('click', function (e) {
          _this7.moveSlide(e.target.closest('.thumb-button'), true);
        });
        this.observerOptions = {
          root: this.slider,
          threshold: 1
        };
        this.observer = new IntersectionObserver(this.observerCallback, this.observerOptions);
        this.slides.forEach(function (slide) {
          return _this7.observer.observe(slide);
        });
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.scrollToStart();
        this.addEvents();
        this.slider.classList.remove('is-hidden');
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define('product-gallery', ProductGallery);
}
if (!window.customElements.get('product-form')) {
  var ProductForm = /*#__PURE__*/function (_HTMLElement4) {
    function ProductForm() {
      var _this8;
      _classCallCheck(this, ProductForm);
      _this8 = _callSuper(this, ProductForm);
      _defineProperty(_this8, "_initTolstoy", function () {
        var myCallback = function myCallback() {
          if (window.dataEvents && window.dataEvents.atc) window.dataEvents.atc();
        };
        var options = {};
        window.tolstoyWidget.subscribe("tolstoy_add_to_cart", myCallback.bind(_this8), options);
      });
      _this8.hardDisabled = _this8.dataset.disabled === 'true';
      _this8.comingSoon = _this8.dataset.comingSoon === 'true';
      _this8.isPreorder = _this8.dataset.preorder === 'true';
      _this8.isTest = _this8.dataset.test === 'true';
      _this8.isCartPage = document.body.classList.contains('template-cart');
      _this8.disabled = false;
      _this8.productId = parseInt(_this8.dataset.productId);
      _this8.cartForm = document.querySelector('cart-form');
      _this8.form = _this8.querySelector('form');
      _this8.submitButton = _this8.querySelector('[type="submit"]');
      _this8.ctaDefault = _this8.dataset.cta;
      _this8.ctaOos = _this8.dataset.ctaOos;
      _this8.btnText = _this8.submitButton.querySelector('[data-cta]');
      _this8.btnPrice = _this8.submitButton.querySelector('[data-price]');
      return _this8;
    }
    _inherits(ProductForm, _HTMLElement4);
    return _createClass(ProductForm, [{
      key: "_handleTolstoy",
      value: function _handleTolstoy() {
        var _this9 = this;
        if (window.tolstoyWidget) {
          this._initTolstoy();
        } else {
          window.addEventListener("tolstoyWidgetReady", function () {
            _this9._initTolstoy();
          });
        }
      }
    }, {
      key: "disableForm",
      value: function disableForm(_ref2) {
        var available = _ref2.available;
        console.log('available', available, this.hardDisabled);
        var disable = !available;
        if (disable || this.hardDisabled) {
          this.disabled = true;
          this.btnText.textContent = this.ctaOos;
          if (this.btnPrice) this.btnPrice.hidden = true;
          this.classList.add('disabled-cart');
          this.submitButton.classList.add('disabled');
        } else {
          this.disabled = false;
          this.btnText.textContent = this.ctaDefault;
          if (this.btnPrice) this.btnPrice.hidden = false;
          this.classList.remove('disabled-cart');
          this.submitButton.classList.remove('disabled');
        }
      }
    }, {
      key: "setButton",
      value: function setButton(buttonText) {
        var disable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        this.submitButton.textContent = buttonText;
        this.submitButton.disabled = disable;
      }
    }, {
      key: "handleComingSoon",
      value: function handleComingSoon() {
        /* klaviyo popup */
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'TrfFTY']);
        return;
      }
    }, {
      key: "onSubmitHandler",
      value: function onSubmitHandler(e) {
        var _this10 = this;
        e.preventDefault();
        if (this.hardDisabled) return false;
        if (this.comingSoon || this.disabled) return this.handleComingSoon();
        this.submitButton.classList.add('working');
        var body = (0,_api_form__WEBPACK_IMPORTED_MODULE_0__.serializeForm)(this.form);
        var alert = '';
        fetch("".concat(window.KROWN.settings.routes.cart_add_url, ".js"), {
          body: body,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          method: 'POST'
        }).then(function (res) {
          return res.json();
        }).then(function (res) {
          if (res.status === 422) {
            /* wrong stock logic alert */
            alert = document.createElement('span');
            alert.className = 'alert alert--error';
            alert.innerHTML = typeof res.description === 'string' ? res.description : res.message;
          } else {
            if (_this10.test) if (_this10.cartForm) {
              /* qty limit 1 */
              if (_this10.cartForm.hasItem(_this10.dataset.productId)) {
                _this10.submitButton.classList.add('disabled');
                _this10.disabled = true;
              }
            }
          }
          _this10.disableIfTest();
          if (window.dataEvents && window.dataEvents.atc) window.dataEvents.atc();
          return window.refreshCart(true, true, true);
        })["catch"](function (e) {
          console.log(e);
        })["finally"](function () {
          _this10.submitButton.classList.remove('working');
        });
      }
    }, {
      key: "disableIfTest",
      value: function disableIfTest() {
        /* if we are a test, disable */
        if (!this.isTest || !this.cartForm || !this.cartForm.hasItem(this.dataset.productId)) return;
        this.submitButton.classList.add('disabled');
        this.disabled = true;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this11 = this;
        if (!this.isCartPage) {
          if (!this.form) return;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.ADD_TO_CART = new Event('add-to-cart');
        }
        if (document.body.classList.contains('touchevents')) {
          this.submitButton.addEventListener('touchend', function () {
            _this11.submitButton.click();
          });
        }
        this._handleTolstoy();
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define('product-form', ProductForm);
}
if (!window.customElements.get('buy-box')) {
  var BuyBox = /*#__PURE__*/function (_HTMLElement5) {
    function BuyBox() {
      var _this12;
      _classCallCheck(this, BuyBox);
      _this12 = _callSuper(this, BuyBox);
      _this12.sellingPlan = _this12.querySelector('[name="selling_plan"]');
      _this12.planOptions = Array.from(_this12.getElementsByClassName('selling-plan'));
      _this12.variantId = _this12.querySelector('[name="id"]');
      return _this12;
    }
    _inherits(BuyBox, _HTMLElement5);
    return _createClass(BuyBox, [{
      key: "setSellingPlan",
      value: function setSellingPlan(id) {
        this.sellingPlan.value = id;
      }
    }, {
      key: "hideSellingPlansById",
      value: function hideSellingPlansById(id) {
        this.planOptions.map(function (plan) {
          return plan.hidden = plan.dataset.variantId !== id;
        });
        /* TODO: select first visible */
      }
    }, {
      key: "setVariantId",
      value: function setVariantId(id) {
        this.variantId.value = id;
        // this.hideSellingPlansById(id);
      }
    }, {
      key: "addEvents",
      value: function addEvents() {
        var _this13 = this;
        this.addEventListener('change', function (e) {
          var input = e.target.closest('input');
          if (input.name === 'purchase_option') {
            _this13.setSellingPlan(input.value);
          }
        });
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.addEvents();
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define('buy-box', BuyBox);
}
})();

/******/ })()
;